import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.checkAuth().pipe(
    map(res => {
      if (!res.data?.auth) {
        return true;
      }
      return router.createUrlTree(['/']);
    }),
    catchError(() => of(true))
  );
};
